type Data = string|number|null;

type Parameters = {
  data: Data,
  check: string,
  comparison: Data,
}

export default class ConditionalCheck {
  /**
   * Check if the given data is truthy
   */
  isTruthy(comparison: Data): boolean {
    return !!comparison;
  }

  /**
   * Check if the given data is falsy
   */
  isFalsy(comparison: Data): boolean {
    return !this.isTruthy(comparison);
  }

  /**
   * Check if the given data and the comparison are equal
   */
  isEqual(comparison: Data, data: Data): boolean {
    // eslint-disable-next-line eqeqeq
    return data == comparison;
  }

  /**
   * Check if the given data and the comparison are not equal
   */
  isNotEqual(comparison: Data, data: Data): boolean {
    return !this.isEqual(comparison, data);
  }

  /**
   * Check if the given data is null
   */
  isNull(comparison: Data): boolean {
    return comparison === null;
  }

  /**
   * Check if the given data is not null
   */
  isNotNull(comparison: Data): boolean {
    return comparison !== null;
  }

  /**
   * Check if the given data passes the given check
   */
  static passes(parameters: Parameters): boolean {
    if (!parameters.check || (!['isNull', 'isNotNull'].includes(parameters.check) && [null, undefined].includes(parameters.comparison))) {
      return false;
    }

    const checkClass = new ConditionalCheck();
    if (!(typeof checkClass[parameters.check] === 'function')) {
      return false;
    }

    return checkClass[parameters.check](parameters.comparison, parameters.data);
  }
}
